import store from "../redux/store";
import Web3 from "web3";
import {makeBatchRequest} from "./promisify";
import {updateBalances, updateInfo, updateStaked, updateTotals} from "../redux/slices/coineusSlice";
import coineus_abi from "../abis/ceus_abi.json";
import ceusone_abi from "../abis/Coineus/CEUSONE.json";
import consensus_abi from "../abis/consensus_abi.json";
import farm_abi from "../abis/MultiRewards.json";

export default function getUserBalances(wallet_address) {
    const _store = store.getState();
    const {pairs, rpc} = _store.coineus;

    if (wallet_address === undefined) {
        return;
    }

    getFUSE(pairs, rpc.fuse, wallet_address);
}

function getFUSE(pairs, rpc, wallet_address) {

    const web3 = new Web3(rpc);
    const ceus_contract = new web3.eth.Contract(coineus_abi, "0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8");
    const ceusone_contract = new web3.eth.Contract(ceusone_abi, "0xE27431FACb1F093BA164c9F86B3f484b39ad54CC");
    const lit_contract = new web3.eth.Contract(coineus_abi, '0xF2C6C1AA2bf8ec40F564Ea8A483F64907ea37A3F');
    const fvksrg_contract = new web3.eth.Contract(coineus_abi, '0xa28a758619ba32B11F8D55eB6C0E1C7E5929bF61');
    const foo_contract = new web3.eth.Contract(coineus_abi, '0x74616164eB1892ceC5fa553D45b3e5D6dF7BC7b9');
    const wfuse_contract = new web3.eth.Contract(coineus_abi, '0x0BE9e53fd7EDaC9F859882AfdDa116645287C629');

    const coineusValidatorAddress = "0xb27feaab8e4f4423e0b9c6f743e26e23a5c0c1b3";
    const consensusAddress = "0x3014ca10b91cb3D0AD85fEf7A3Cb95BCAc9c0f79";
    const consensusContract = new web3.eth.Contract(consensus_abi, consensusAddress);
    const ceusStakingAddress = "0xB79a7A790165B725E9A2ad0E65C4A816B5C0eC57";
    const ceusStakingContract = new web3.eth.Contract(farm_abi, ceusStakingAddress);

    const calls = [
        web3.eth.getBalance(wallet_address),
        ceus_contract.methods.balanceOf(wallet_address).call,
        ceusone_contract.methods.balanceOf(wallet_address).call,
        ceusone_contract.methods.getAccount(wallet_address).call,
        consensusContract.methods.delegatedAmount(wallet_address, coineusValidatorAddress).call,
        lit_contract.methods.balanceOf(wallet_address).call,
        fvksrg_contract.methods.balanceOf(wallet_address).call,
        foo_contract.methods.balanceOf(wallet_address).call,
        wfuse_contract.methods.balanceOf(wallet_address).call,
        ceusStakingContract.methods.balanceOf(wallet_address).call,
    ];

    makeBatchRequest(web3, calls, "get_balances getFUSE()").then(resp => {
        let [
            fuse_balance,
            ceus_balance,
            ceusone_balance,
            ceusone_info,
            staked_fuse_with_coineus,
            lit_balance,
            fvksrg_balance,
            foo_balance,
            wfuse_balance,
            staked_ceus,

        ] = resp;

        //fuse
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: 'native',
            balance: fuse_balance / (10 ** 18)
        }))
        store.dispatch(updateStaked({
            chain: 'fuse',
            contract_address: 'native',
            staked: staked_fuse_with_coineus / (10 ** 18)
        }))

        //wfuse
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0x0BE9e53fd7EDaC9F859882AfdDa116645287C629',//wfuse
            balance: wfuse_balance / (10 ** 18)
        }));

        //ceus
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8',
            balance: ceus_balance / (10 ** 18)
        }))
        store.dispatch(updateStaked({
            chain: 'fuse',
            contract_address: '0x4e69Ae0CD024754655b4eF74F24A8DCB39Ba07e8',
            staked: staked_ceus / (10 ** 18)
        }))

        //ceusone
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0xE27431FACb1F093BA164c9F86B3f484b39ad54CC',
            balance: ceusone_balance / (10 ** 18)
        }))
        store.dispatch(updateInfo({
            chain: 'fuse',
            contract_address: "0xE27431FACb1F093BA164c9F86B3f484b39ad54CC",
            info: (() => {
                const {account, balance, deposits, fees, transfersIn, transfersOut, withdrawals} = ceusone_info;
                return {account, balance, deposits, fees, transfersIn, transfersOut, withdrawals}
            })()
        }));

        //lit
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0xF2C6C1AA2bf8ec40F564Ea8A483F64907ea37A3F',//lit
            balance: lit_balance / (10 ** 18)
        }));

        //fvksrg
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0xa28a758619ba32B11F8D55eB6C0E1C7E5929bF61',//fvksrg
            balance: fvksrg_balance / (10 ** 18)
        }));

        //foo
        store.dispatch(updateBalances({
            chain: 'fuse',
            contract_address: '0x74616164eB1892ceC5fa553D45b3e5D6dF7BC7b9',//foo
            balance: foo_balance / (10 ** 18)
        }));


        store.dispatch(updateTotals('fuse'));
    })
}